/*
 * Copyright Elasticsearch B.V. and/or licensed to Elasticsearch B.V. under one
 * or more contributor license agreements. Licensed under the Elastic License
 * 2.0; you may not use this file except in compliance with the Elastic License
 * 2.0.
 */

// DO NOT MODIFY THIS FILE BY HAND. IT IS GENERATED BY
// `yarn workspace @elastic/esql-definitions generate` FROM
// `elasticsearch/esql/x-pack-esql/definition/functions/std_dev.json`.

import type { DefinitionDocs } from '../../definition_types';

const docs: DefinitionDocs = {
  description: 'The population standard deviation of a numeric field.',
  examples: [
    'FROM employees\n| STATS std_dev_height = STD_DEV(height)',
    'FROM employees\n| STATS stddev_salary_change = STD_DEV(MV_MAX(salary_change))',
  ],
  params: {
    number: '',
  },
};

export default docs;
